import { Button, Stack, Typography } from "@mui/material";
import { useGetDosespotPatientQuery } from "src/api/services/dosespotPatient";
import Spinner from "../Spinner";
import { useCallback, useState } from "react";
import { useAddPatientMutation } from "src/api/services/ePrescribeApi";
import { PatientProfile } from "src/api/types";
import { useGetPatientAddressQuery } from "src/api/services/addressApi";
import DosespotButton from "../DosespotButton";

interface Props {
  patient: PatientProfile;
}

const pharmacyPhoneFormatter = (phoneNumber: string) => {
  return [...phoneNumber].reverse().slice(0, 10).reverse().join("");
};

const DosespotPatient = ({ patient }: Props) => {
  const { data, isLoading, isSuccess } = useGetDosespotPatientQuery(patient.id);
  const { data: address } = useGetPatientAddressQuery(patient.id);
  const [openModal, setOpenModal] = useState(false);
  const [addPatient, { isLoading: isCreating }] = useAddPatientMutation();

  const handleCreate = useCallback(() => {
    if (address == null) {
      alert("No address");
      return;
    }

    const { first_name, last_name, dob, gender, phone_number } =
      patient.profile;

    if (
      first_name == null ||
      last_name == null ||
      dob == null ||
      gender == null ||
      phone_number == null
    ) {
      alert("Missing attribute(s)");
      return;
    }

    addPatient({
      FirstName: first_name,
      LastName: last_name,
      Gender: gender,
      DateOfBirth: new Date(dob),
      NonDoseSpotMedicalRecordNumber: String(patient.id),
      PrimaryPhone: pharmacyPhoneFormatter(phone_number),
      PrimaryPhoneType: "Primary",
      Address1: address.address_line1,
      Address2: address.address_line2 || null,
      City: address.city,
      State: address.state,
      ZipCode: address.zip_code,
      Active: true,
    }).then(() => setOpenModal(true));
  }, [addPatient, address, patient.id, patient.profile]);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" gap={1} alignItems="center">
        <Typography id="dosespot-id-label" fontWeight={600}>
          Dosespot ID:
        </Typography>
        {isLoading ? (
          <Spinner size="20px" />
        ) : isSuccess && data == null ? (
          <Typography aria-labelledby="dosespot-id-label">N/A</Typography>
        ) : (
          <Typography aria-labelledby="dosespot-id-label">
            {data?.external_id}
          </Typography>
        )}
      </Stack>
      {isSuccess && data == null ? (
        <Button
          variant="text"
          size="small"
          loading={isCreating}
          onClick={handleCreate}
        >
          Create
        </Button>
      ) : (
        <DosespotButton
          patientId={patient.id}
          buttonProps={{ size: "small" }}
          openModal={openModal}
        />
      )}
    </Stack>
  );
};

export default DosespotPatient;
